import { TextureRounded } from "@material-ui/icons";
import React from "react";
import {Col, Row,Button,Container,Card} from 'react-bootstrap';
import notFoundIcon from '../../assets/icons/nodata.png';
import Icon from 'react-crud-icons';
import MultiCard from '../multiCard/index'
import JenkinsCard from '../jenkinsCard/index'
import Chart from "../../components/chart";
import { NoSettingsFound } from "../../utilities";
// import "@react-crud-icons/dist/css/react-crud-icons.css";



export function TableHeader (props){
    console.log("header",props)
    return(
        <>
        <thead>
        <tr>
            {props.list.map(item => {
              return(           
                <th>{item}</th>                
            ) })}
        </tr>  
        </thead>

        </>
    )
}

export function TableName (props){
    return(
        <>
         {/* <Row> */}
            <Col xs={6}>
                <div>{props.name}</div>
            </Col>
            <Col xs={6} className="no-padding">
                <Button className="create-az-btn" onClick={() => props.handleOpen()}>Add New</Button>
            </Col>
        {/* </Row> */}
        </>
    )
}

export function TableBody (props){
    console.log(props)
    return(
        <>
            <tbody>
                {props.resourceList.map((resource,index) => {
                    return(
                        <>
                        <tr >
                    {props.headerList.map((item,ind)=>{     
                        const arr = item.split(" ");
                        arr[0]=arr[0].toLowerCase();
                        const keyword = arr.join("");
                                //    let keyword = ((item[0].toLowerCase() + item.substring(1)).replace(/ /g, ""))
                     return (
                        <>
                            {(keyword.includes("Pat")||keyword.includes("Token"))?
                            <td><input className="table-apssword" type="password" value = {resource[keyword]}></input></td>:
                            <td>{resource[keyword]}</td>
                            }    
                         {ind==props.headerList.length-1? <td><Icon name = "delete"  theme = "dark"  size = "small" onClick ={() => props.deleteResource(resource._id,props.url,props.stateVar)}/></td>:null}
                        </>
                     )
                        })}
                </tr></>                                                       
                )
                    })
                }
            </tbody>
        </>
    )
}
export function TableBodyWithCondition (props){
    return(
        <>
                {props.data.map(muleItem => {
                    if (muleItem.muleOrg === props.muleOrgItem.organization || muleItem.organizationID === props.muleOrgItem.organization ) {
                        if(props.type === "mule"){
                            let headerContent={"Anypoint Client ID":muleItem.muleClientId, "Anypoint Client Secret":muleItem.muleClientSecret}
                            let footerContent={"Anypoint Username":muleItem.muleUsername, "Anypoint Password": muleItem.mulePassword }
                            return(
                                 < >
                                       <MultiCard headerData={headerContent} footerData={footerContent} cardType="grid"  theme="dark" />
                                 </>
                                
                            )
                        }else{
                            let chartContent = { "RTF Name": muleItem.rtfName, "RTF target Cluster": muleItem.targetCluster, "Status": muleItem.status, "RTF ID" : muleItem.rtfId}
                                return (
                                    <Col >
                                        <Chart chartData={chartContent} gridval="6" theme="light"/>
                                    </Col>
                                )
                        }
                        
                    } else {
                        return null;
                    }    
                })}
        </>
    )
}
export function TableBodyforGke (props){
    return(
        <>
                {props.data.map(gkeItem => {
                    if (gkeItem.serviceAccEmail === props.gkeAccount.serviceAccEmail  ) {
                        if(props.type === "gke"){
                             let headerContent={"Cluster":gkeItem.gkeCluster, "Region": gkeItem.gkeRegion }
                             let footerContent={}
                             return(
                                 < >
                                       <MultiCard headerData={headerContent} footerData={footerContent} cardType="grid"  theme="dark" />
                                 </>
                                
                            )
                        }
                        // else{
                        //     let chartContent = { "RTF Name": muleItem.rtfName, "RTF target Cluster": muleItem.targetCluster, "Status": muleItem.status, "RTF ID" : muleItem.rtfId}
                        //         return (
                        //             <Col >
                        //                 <Chart chartData={chartContent} gridval="6" theme="light"/>
                        //             </Col>
                        //         )
                        // }
                        
                    } else {
                        return null;
                    }    
                })}
        </>
    )
}
export function Table(props){
    return(
        <> 
        <div>
                        <Row className="no-margin">
                            <Col xs={12} className=" no-margin">
                            <Row className="settings-details-row "><TableName name={props.name} handleOpen={props.handleOpen}/>
                                   <Row className=" settings-details-row setting-table-wrap">
                                    {
                                        props.resourceList.length ?
                                            <div className=" table-wrap">    
                                                <table className="custom-table" hover>
                                                   <TableHeader list={props.headerList}/>
                                                   <TableBody headerList={props.headerList} resourceList={props.resourceList} deleteResource={props.deleteResource} url={props.url} stateVar={props.stateVar} />                                                    
                                                </table>
                                            </div> :<NoSettingsFound message={props.message}/> }
                                </Row>
                            </Row>                               
                             
    
                            </Col>
                        </Row>
    
                    </div>
        </>
                                                 
                       /* <Row xs={2} md={4} className="card-row" >


                        {props.resourceList.length ?
                        props.resourceList.map((item,ind)=>{  
                         return(   
                        <Col>
                          <ProjectCard value1='username' value2={item.gitUsername} value3='gitPat' value4={item.gitPat}/>

                      
                        </Col>
                        )})
                        :<NoSettingsFound message={props.message}/> } 
                        </Row> */

    
        
    )
}